import React from 'react'

const StudyEditBlockingOverlay = ({ title, message }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(255, 255, 255, 0.92)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div
        style={{
          maxWidth: '480px',
          textAlign: 'center',
          lineHeight: 1.5,
        }}
      >
        <h4 style={{ fontWeight: 600, marginBottom: '12px' }}>{title}</h4>
        <p style={{ margin: 0, color: '#495057', whiteSpace: 'normal' }}>{message}</p>
      </div>
    </div>
  )
}

export default StudyEditBlockingOverlay
